import Swiper from 'swiper';

import 'swiper/css/pagination';
import 'swiper/css';
import { Navigation, Pagination } from 'swiper/modules';

export default class Header {
	constructor(root) {
		this.root = root;
		this.sliderEl = root?.querySelector('.swiper');
		this.slider = new Swiper(this.sliderEl, {
			modules: [Navigation, Pagination],
			slidesPerView: 1,
			loop: true,
			navigation: {
				enabled: true,
				nextEl: root?.querySelector('.swiper-button-next'),
				prevEl: root?.querySelector('.swiper-button-prev'),
			},
			pagination: {
				el: '.swiper-pagination',
				enabled: true,
				type: 'fraction',
				renderFraction: (currentClass, totalClass) => `
					<span class="${currentClass}"></span>
					van
					<span class="${totalClass}"></span>
				`,
			},
		});
	}
}

document.querySelectorAll('.header').forEach((header) => {
	new Header(header);
});
